import { render, staticRenderFns } from "./table_config_basicinfo_add.vue?vue&type=template&id=0befdb77"
import script from "./table_config_basicinfo_add.vue?vue&type=script&lang=js"
export * from "./table_config_basicinfo_add.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports